import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const RouteBodyAttributes = () => {
  const location = useLocation();

  useEffect(() => {
    document.body.setAttribute('data-route', location.pathname);

    return () => {
      document.body.removeAttribute('data-route');
    };
  }, [location.pathname]);

  return null;
};
